import {
  CaretDownOutlined,
  QuestionCircleOutlined,
  QuestionCircleFilled,
} from '@ant-design/icons';
import * as S from '@unionfab/ufc-shop-commons';
import {
  getLocale,
  i18nDateTimeFormat,
  i18nFormat,
} from '@unionfab/ufc-shop-commons';
import { getUfcShopComposedApi } from '@unionfab/ufc-shop-commons';
import cn from 'classnames';
import { CSSProperties } from 'react';
import { useQuery } from 'react-query';

import { getUseShopQuoteStoreByCode } from '@/stores';

import styles from './index.module.less';
import { ShopQuoteMinOrderFeeTips } from './ShopQuoteMinOrderFeeTips';
// import { ShopQuoteSubtotalCurrencyTips } from './ShopQuoteSubtotalCurrencyTips';
import { Tooltip } from 'antd';
import { ShopQuoteTotalTips } from '../../ShopQuoteCheckoutPage/ShopQuoteCheckoutSummary/ShopQuoteTotalTips';
export interface ShopOrdertQuotationInfoProps {
  className?: string;
  style?: CSSProperties;

  orderCode: string;
}

export const ShopOrderQuotationInfo = ({
  className,
  style,

  orderCode,
}: ShopOrdertQuotationInfoProps) => {
  const { shopOrder, shopOrderQuotation } = getUseShopQuoteStoreByCode(
    orderCode,
  )(s => ({
    shopOrder: s.shopOrder,
    shopOrderQuotation: s.shopOrderQuotation,
  }));

  const { production } = shopOrderQuotation;

  const isRfq = !!production && production.status !== 'OK';

  const minProductionFee = S.get(production, o => o.minProductionFee.amount);
  const minOrderFeeCurrency = S.get(
    production,
    o => o.minProductionFee.currency,
  );

  // 仅在服务端保存完成后再触发交期计算，避免使用本地未持久化的数据
  const { isLoading } = getUseShopQuoteStoreByCode(orderCode)(s => ({
    isLoading: s.isLoading,
  }));

  // skuId 变化需要重新计算交期
  const skuKey = (S.get(shopOrder, o => o.items) || [])
    .map(i => i?.skuId || '')
    .join('|');

  // 交期（预计发货日期）改为后端接口计算
  const { data: shipmentDateStr } = useQuery({
    enabled: !!orderCode && !isLoading,
    refetchOnWindowFocus: false,
    queryKey: ['calcDelivery', orderCode, skuKey],
    queryFn: () =>
      getUfcShopComposedApi().shopOrderQueryApi.calcDelivery(orderCode),
  });

  return (
    <div
      style={style}
      className={cn(styles.shopOrdertQuotationInfo, className)}
    >
      <h3 className={styles.title}>{i18nFormat('Order Summary')}</h3>
      <div className={styles.quoteInfoItem}>
        <div className={styles.flexStart}>
          <span className={styles.subTitle}>
            {i18nFormat('Subtotal')}:&nbsp;
            <CaretDownOutlined />
          </span>
        </div>
        <div className={styles.priceInfo}>
          <span>{S.get(production, q => q.shopOrderSubtotalPrice)}</span>
        </div>
      </div>
      <div className={styles.subQuoteInfoItem}>
        <div className={styles.flexStart}>
          <span className={styles.subTitle}>
            {i18nFormat('Production Price')}:
          </span>
        </div>
        <div className={styles.priceInfo}>
          {S.get(production, q => q.shopOrderProductionPrice)}
        </div>
      </div>
      <div className={styles.subQuoteInfoItem}>
        <div className={styles.flexStart}>
          <span className={styles.subTitle}>
            {i18nFormat('Additional Charges')}:&nbsp;
            <Tooltip
              title={i18nFormat(
                'This fee covers the minimum order price and value-added costs, such as post-processing.',
              )}
              className={styles.vatIcon}
            >
              <QuestionCircleFilled
                style={{ color: '#faad14', marginLeft: 4 }}
              />
            </Tooltip>
          </span>
        </div>
        <div className={styles.priceInfo}>
          {isRfq
            ? '-'
            : S.toPriceStringWithOption(minProductionFee, {
                currency: minOrderFeeCurrency,
                rfq: isRfq,
              })}
        </div>
      </div>
      <div className={styles.quoteInfoItem}>
        <span className={styles.subTitle}>{i18nFormat('Shipment Date')}:</span>
        <div className={styles.priceInfo}>
          {
            S.getShopOrderLeadTimes(shopOrder, null, shipmentDateStr)
              .leadTimeStr
          }
        </div>
      </div>
      <div className={styles.shippingTip}>
        *For reference only. The shipping date is based on the completion date
        of quality inspection.
      </div>
    </div>
  );
};

ShopOrderQuotationInfo.displayName = 'ShopOrderQuotationInfo';
